import {makeStyles} from "@material-ui/core/styles"
export default makeStyles({
    media:{
        height: 200,
    },
    border:{
        border:'solid',
    },
    fullHeightCard: {
        height: "100%",
    },
    card: {
        display:'flex',
        flexDirection: 'column',
        justifyContent: 'space=between',
        borderBottom: '10px solid white',
        height:'31rem',
        boxShadow:'0 0 5px 2px rgba(10,50,60,0.5)',
        transition:'0.3s ease'
    },
    activeCard :{
        boxShadow:'0 0 5px 2px black',
        transform:'scale(1.03,1.03)'
    },
    grid:{
        display:'flex',
    },
    details: {
        display:'flex',
        justifyContent:'space-between',
        margin:'20px',
    },
    title:{
        padding:'0 16px',
    },
    cardAction:{
        padding:'0 16px 3px 16px',
        display:'flex',
        justifyContent:'space-between',
    }
}) 